var _style, _defs, _path, _path2, _path3, _path4, _path5, _defs2, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDenistry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 103 102",
    style: {
      enableBackground: "new 0 0 103 102"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;}\r\n\t.st2{clip-path:url(#SVGID_00000181058949699151933420000011893366957072601477_);}\r\n\t.st3{fill:#E86E7B;}\r\n\t.st4{clip-path:url(#SVGID_00000136386179036813315500000001890334457926925988_);}\r\n")), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 0.5,
    y: 0,
    width: 102,
    height: 102
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000118369286271685049250000001486866756243169957_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000118369286271685049250000001486866756243169957_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M98.2,93.5h-85c-1.1,0-2.2-0.4-3-1.2c-0.8-0.8-1.2-1.9-1.2-3v-85c0-1.1-0.4-2.2-1.2-3C7,0.4,5.9,0,4.8,0 s-2.2,0.4-3,1.2C0.9,2,0.5,3.1,0.5,4.2v85c0,3.4,1.3,6.6,3.7,9s5.6,3.7,9,3.7h85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3 s-0.4-2.2-1.2-3C100.5,93.9,99.4,93.5,98.2,93.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M64.3,85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3V51c0-1.1-0.4-2.2-1.2-3c-0.8-0.8-1.9-1.2-3-1.2 s-2.2,0.4-3,1.2S60,49.9,60,51v29.8c0,1.1,0.4,2.2,1.2,3C62,84.6,63.1,85,64.3,85z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M30.2,85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3V51c0-1.1-0.4-2.2-1.2-3s-1.9-1.2-3-1.2 s-2.2,0.4-3,1.2S26,49.9,26,51v29.8c0,1.1,0.4,2.2,1.2,3C28,84.6,29.1,85,30.2,85z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M81.2,85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3v-51c0-1.1-0.4-2.2-1.2-3c-0.8-0.8-1.9-1.2-3-1.2 s-2.2,0.4-3,1.2c-0.8,0.8-1.2,1.9-1.2,3v51c0,1.1,0.4,2.2,1.2,3C79,84.6,80.1,85,81.2,85z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M47.2,85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3v-51c0-1.1-0.4-2.2-1.2-3s-1.9-1.2-3-1.2 s-2.2,0.4-3,1.2c-0.8,0.8-1.2,1.9-1.2,3v51c0,1.1,0.4,2.2,1.2,3C45,84.6,46.1,85,47.2,85z"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000053511117946171988110000000946889458178754218_",
    x: 10.5,
    y: 13.8,
    width: 82,
    height: 82
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000021840238779722549670000014063379623619273661_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000053511117946171988110000000946889458178754218_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000021840238779722549670000014063379623619273661_)"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8,95.8c-2.7,0-5.1-1-7.2-2.7c-1.7-2.1-2.7-4.4-2.7-7.2V65c0-1-0.3-1.7-1-2.4c-0.7-0.7-1.4-1-2.4-1 c-1,0-1.7,0.3-2.4,1c-0.7,0.7-1,1.4-1,2.4v20.8c0,2.1-0.7,4.4-2.1,6.2c-1.4,1.7-3.1,3.1-5.5,3.4c-2.1,0.7-4.4,0.3-6.5-0.3 c-2.1-0.7-3.8-2.4-4.8-4.1c-8.2-14-19.1-35.2-19.1-56.7c0-2.7,0.3-5.5,1.4-7.9c1-2.4,2.4-4.8,4.4-6.8c2.1-2.1,4.1-3.4,6.8-4.4 c2.4-1,5.1-1.4,7.9-1.4c4.4,0,9.2,0.7,13.3,2.1c2.4,0.7,4.8,1.4,7.2,1.4c2.4,0,4.8-0.7,7.2-1.4c4.4-1.4,8.9-2.1,13.3-2.1 c2.7,0,5.5,0.3,7.9,1.4c2.4,1,4.8,2.4,6.8,4.4c2.1,2.1,3.4,4.1,4.4,6.8c1,2.4,1.4,5.1,1.4,7.9C92.2,55.8,81.2,77,73,91 c-1,1.4-2.1,2.7-3.8,3.8C68.2,95.4,66.5,95.8,64.8,95.8z M51.5,54.8c2.7,0,5.5,1,7.2,3.1c2.1,2.1,3.1,4.4,3.1,7.2v20.8 c0,0.7,0.3,1.4,0.7,2.1s1,1,1.7,1c0.7,0.3,1.4,0,2.1,0c0.7-0.3,1-0.7,1.4-1.4c7.9-13.3,18.1-33.5,18.1-53.3c0-1.7-0.3-3.8-1-5.5 c-0.7-1.7-1.7-3.1-3.1-4.4c-1.4-1.4-2.7-2.4-4.4-3.1c-1.7-0.7-3.4-1-5.5-1c-3.8,0-7.9,0.7-11.6,1.7c-2.7,1-5.8,1.4-8.9,1.7 c-3.1,0-6.2-0.7-8.9-1.7c-3.8-1.4-7.5-1.7-11.6-1.7C17,20.3,17,33.2,17,33.9c0,19.8,10.3,40,18.1,53.3c0.3,0.7,1,1,1.4,1.4 c0.7,0.3,1.4,0.3,2.1,0c0.7-0.3,1.4-0.7,1.7-1c0.3-0.7,0.7-1,0.7-2.1V64.7c0-2.7,1-5.5,3.1-7.2C46,55.8,48.8,54.8,51.5,54.8z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDenistry);
export default __webpack_public_path__ + "static/media/Denistry.a5a691d738f3233629c31480ea75da4e.svg";
export { ForwardRef as ReactComponent };